import React, { useState, useMemo } from "react";

import ReportManagement from "./ReportManagement/ReportManagement";
import Feedback from "./Feedback/Feedback";

const ReportFeedback: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"report" | "feedback">("report");

  const TabContent = useMemo(
    () => ({
      report: <ReportManagement />,
      feedback: <Feedback />,
    }),
    []
  );

  return (
    <div>
      <section className="flex flex-wrap items-center justify-between gap-2">
        <h1 className="text-xl font-semibold text-grease-100 tracking-tight">Reports & Feedback</h1>

        <nav className="flex flex-wrap items-center text-sm text-lightgray-200 gap-x-2 gap-y-1 mt-1">
          <span className="st-home text-lightgray-200 text-sm" aria-hidden="true" />
          <a href="#" className="hover:text-royalblue-100 transition-colors duration-150">
            Home
          </a>
          <span className="st-arrow-right text-lightgray-200 text-xs" aria-hidden="true" />
          <span className="text-royalblue-100 font-medium">Reports & Feedback</span>
        </nav>
      </section>

      <section className="mt-6">
        <div className="overflow-x-auto">
          <div className="flex items-center gap-2 mx-auto my-4 p-2 bg-blue-100 rounded-full w-max">
            {(["report", "feedback"] as const).map((tab) => (
              <button
                key={tab}
                className={`px-6 py-2 rounded-full text-sm font-medium whitespace-nowrap ${
                  activeTab === tab ? "bg-white text-royalblue-100" : "text-lightgray-200"
                }`}
                onClick={() => setActiveTab(tab)}
              >
                {tab === "report" ? "Report Management" : "Feedback"}
              </button>
            ))}
          </div>
        </div>
      </section>

      {TabContent[activeTab]}
    </div>
  );
};

export default ReportFeedback;
